import { clsx } from 'clsx'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const ProgressContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${rem(4)};
  background-color: ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.round};
`

const ProgressFill = styled.div`
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  width: var(--progress, 0%);
  height: 100%;
  border-radius: ${props => props.theme.borderRadius.round};
  background: ${props => props.theme.palette.highlight.primary.normalForeground};

  &.completed {
    background: ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
  }
`

interface Props {
  progress: number
  contributorsCount: number
}

function WeddingGiftContributionProgress({ progress, contributorsCount }: Props) {
  const intl = useIntl()
  const isFullyGifted = progress >= 100

  return (
    <Sheet background="light-background" borderRadius="M" padding={8}>
      <Group direction="vertical" gap={4}>
        <Group direction="horizontal" gap={8} horizontalAlign="space-between">
          <Group direction="horizontal" gap={4} wrap="nowrap">
            <BodyText variant="small" weight="bold">
              {intl.formatMessage(
                { defaultMessage: '{progress}%', id: 'Ubbk6M1lWuqe-8025Q4q', description: 'Percentage funded value shown in wedding gift contribution progress.' },
                { progress },
              )}
            </BodyText>
            <BodyText variant="small">
              {intl.formatMessage({ defaultMessage: 'gifted', id: 'K8SrfPq3GOeJIhIpUrda', description: 'Label after percentage funded in wedding gift contribution progress.' })}
            </BodyText>
          </Group>
          <Group direction="horizontal" gap={4} wrap="nowrap">
            <BodyText variant="small" weight="bold">{contributorsCount}</BodyText>
            <BodyText variant="small">
              {intl.formatMessage(
                { defaultMessage: '{contributorsCount, plural, one {contributor} other {contributors}}', id: '7OszdG9AOIuK1Ig4LCPo', description: 'Contributor count label in wedding gift contribution progress.' },
                { contributorsCount },
              )}
            </BodyText>
          </Group>
        </Group>
        <ProgressContainer>
          <ProgressFill style={{ '--progress': `${progress}%` } as React.CSSProperties} className={clsx({ completed: isFullyGifted })} />
        </ProgressContainer>
      </Group>
    </Sheet>
  )
}

export default WeddingGiftContributionProgress
